import { plainToClass } from "class-transformer";

import endpoint from 'utils/endpoint';
import Attachment from 'domain/model/attachment';
import Base from 'domain/repository/base';

export default class CompanyAttachmentRepository extends Base {
  async fetchIndex({
    companyId,
  }: {
    companyId: string;
  }) {
    return this.api.get(endpoint.company.attachments.index(companyId), {}).then(res => {
      return res.data.map((r: Attachment) => plainToClass(Attachment, r, { excludeExtraneousValues: true }))
    });
  };
}
